/* import __COLOCATED_TEMPLATE__ from './company-user-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();